import { TDeviceType } from '@cian/ui-kit';
import { IBuildersList } from '../../types/builders';
import { getPageData } from './getPageData';
import { createCianAnalyticsProducts } from './createCianAnalyticsProducts';
export interface ICreateCianAnalyticsPageViewObjectParams {
  buildersList?: IBuildersList;
  deviceType: TDeviceType;
  userId?: number;
  abGroup: number;
}

export function createCianAnalyticsPageViewObject({
  buildersList,
  deviceType,
  userId,
  abGroup,
}: ICreateCianAnalyticsPageViewObjectParams) {
  const cianAnalyticsPageViewObject = {
    page: getPageData({ pageNumber: buildersList?.page, deviceType }),
    products: createCianAnalyticsProducts(buildersList),
    user: userId
      ? {
          abGroup,
          userId,
        }
      : {},
  };

  return cianAnalyticsPageViewObject;
}
